import CancelSmall from '@/icons/cancel-small';
import { Button } from '@/shadcn-ui/button';
import { motion } from 'motion/react';

interface FilterPillProps {
  name: string;
  onClickDelegate: () => void;
}

export default function FilterPill({ name, onClickDelegate }: FilterPillProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{
        opacity: 1,
        scale: 1,
      }}
      exit={{
        opacity: 0,
        scale: 0.9,
      }}
      transition={{
        duration: 0.1,
        ease: 'easeOut',
      }}
    >
      <Button
        type="button"
        variant="clear"
        onClick={onClickDelegate}
        className="flex h-auto min-w-fit snap-center flex-row items-center justify-center gap-[4px] whitespace-nowrap rounded-[100px] border-[1px] border-solid border-flexcar-neutral80 bg-flexcar-neutral100 py-[4px] pl-[8px] pr-[4px] hover:bg-flexcar-neutral90"
      >
        <p className="body3-strong truncate">
          {name} <CancelSmall className="inline-block h-[16px] w-[16px]" />
        </p>
      </Button>
    </motion.div>
  );
}
